module.exports = "/images/logo.png?0548195799e711fba57d4541f385d80c";